export const getUserRole = (user) => {
  const role = Array.isArray(user?.role) ? user.role[0] : user?.role;

  return {
    role,
    userType: user?.userType,
  };
};